import { API } from "aws-amplify";

export const GET_VPP_KEY_SITE_REQUEST = "@@vpp/GET_VPP_KEY_SITE_REQUEST";
export const GET_VPP_KEY_SITE_SUCCESS = "@@vpp/GET_VPP_KEY_SITE_SUCCESS";
export const GET_VPP_KEY_SITE_FAILURE = "@@vpp/GET_VPP_KEY_SITE_FAILURE";

export function getVppKeyForSite(siteId) {
  return async (dispatch) => {
    if (!siteId) return;
    dispatch({
      type: GET_VPP_KEY_SITE_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/vpp_key/${siteId}`);
      dispatch({
        type: GET_VPP_KEY_SITE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_VPP_KEY_SITE_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_VPP_KEY = "@@vpp/CLEAR_VPP_KEY";

export function clearVppKey() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_VPP_KEY,
    });
  };
}
